import { render, staticRenderFns } from "./PaginationShowMore.vue?vue&type=template&id=24329fe5&"
import script from "./PaginationShowMore.vue?vue&type=script&lang=js&"
export * from "./PaginationShowMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports